import axios from 'axios';
import $ from 'jquery';
import messages from '../statics/messages.json';
import { useNavigate } from 'react-router-dom';
const ReceiveContext = () => {
    const navigate = useNavigate();
    // Check if running locally
        const isLocal = window.location.hostname === "localhost";
    
        // Get port from config for local, empty for production
        const port = isLocal ? messages.node_server_port : "";
    
        // Build the base URL
        const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
    // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
    const productionDetailsFeatch = async (index, maxRecords, searchTerm,status,daysFilter,sortColumn,sortDirection,POLinesData,POValue,prcPartValue,VendorValue,startDate,endDate,exports,newOrders) => {
    try {
        if(exports === true){
            exports = "yes"
        }else{
            exports = "no"
        }
        let url = `${contextPath}/receivingService/productionDetailsFeatch`;
        const params = {
            index: index,
            maxRecords: maxRecords,
            searchTerm: searchTerm,
            status:status,
            days:daysFilter,
            sortColumn:sortColumn,
            sortDirection:sortDirection,
            POLinesData:POLinesData,
            POValue:POValue,
            prcPartValue:prcPartValue,
            VendorValue:VendorValue,
            startDate:startDate,
            endDate:endDate,
            export:exports,
            newOrders:newOrders,
        };
        
        console.log('🔵 ReceiveContext API Request:', { url, params });
        
        const response = await axios.get(url, {
            params: params,
            withCredentials: true,
        });
        
        console.log('🟢 ReceiveContext API Response:', {
            status: response.status,
            totalRecords: response.data.totalRecords,
            productionCount: response.data.production?.length,
            production: response.data.production
        });
        
        // Check the response status
        if (response.status !== 200) throw new Error(`Can't open with status ${response.status}`);
        
        return response.data;

    } catch (err) {
        console.error('🔴 ReceiveContext API Error:', {
            message: err.message,
            status: err.status,
            response: err.response,
            stack: err.stack
        });
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        return null;
    }
};

const VendorFeatch =async ()=>{
    try {
        const response = await axios.get(`${contextPath}/receivingService/getVendors`,{withCredentials: true,});

        // Check the response status
        if (response.status !== 200) throw new Error(`Can't open with status ${response.status}`);
        
        return response.data;

    } catch (err) {
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        console.error("Fetch error:", err);
        return null;
    }
}

const getPOValidationData = async (index, maxRecords, searchTerm, status, dueDays, sortColumn, sortDirection, po, prcpart, vendor, startDate, endDate, exports, newOrders) => {
    try {
        if(exports === true){
            exports = "yes"
        } else {
            exports = "no"
        }
        let url = `${contextPath}/receivingService/getPOValidationData`;
        const params = {
            index: index,
            maxRecords: maxRecords,
            searchTerm: searchTerm,
            status: status,
            dueDays: dueDays,
            sortColumn: sortColumn,
            sortDirection: sortDirection,
            po: po,
            prcpart: prcpart,
            vendor: vendor,
            startDate: startDate,
            endDate: endDate,
            exports: exports,
            newOrders: newOrders,
        };
        
        console.log('🔵 ReceiveContext - getPOValidationData Request:', { url, params });
        
        const response = await axios.get(url, {
            params: params,
            withCredentials: true,
        });
        
        console.log('🟢 ReceiveContext - getPOValidationData Response:', {
            status: response.status,
            totalRecords: response.data.totalRecords,
            productionCount: response.data.production?.length,
            production: response.data.production
        });
        
        // Check the response status
        if (response.status !== 200) throw new Error(`Can't open with status ${response.status}`);
        
        return response.data;

    } catch (err) {
        console.error('🔴 ReceiveContext - getPOValidationData Error:', {
            message: err.message,
            status: err.status,
            response: err.response,
            stack: err.stack
        });
        if(err.status === 401){
            localStorage.removeItem('jwt');
            navigate('/login');
        }
        return null;
    }
}

const updatePOReview = async (poNum, reviewed) => {
    try {
        const response = await axios.patch(
            `${contextPath}/orderService/updatePOReview`,
            {
                poNum: poNum,
                reviewed: reviewed
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
        );
        
        if (response.status === 200 && response.data.success) {
            return { success: true, message: response.data.message, data: response.data.data };
        }
        return { success: false, message: response.data.message || 'Failed to update PO review status' };
    } catch (err) {
        console.error('🔴 ReceiveContext - updatePOReview Error:', err);
        return { success: false, message: err.response?.data?.message || 'Error updating PO review status' };
    }
};

const updatePOAccept = async (poNum, accepted) => {
    try {
        const response = await axios.patch(
            `${contextPath}/orderService/updatePOAccept`,
            {
                poNum: poNum,
                accepted: accepted
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
        );
        
        if (response.status === 200 && response.data.success) {
            return { success: true, message: response.data.message, data: response.data.data };
        }
        return { success: false, message: response.data.message || 'Failed to update PO accept status' };
    } catch (err) {
        console.error('🔴 ReceiveContext - updatePOAccept Error:', err);
        return { success: false, message: err.response?.data?.message || 'Error updating PO accept status' };
    }
};

const updatePOArchive = async (poNum, archived) => {
    try {
        const response = await axios.patch(
            `${contextPath}/orderService/updatePOArchive`,
            {
                poNum: poNum,
                archived: archived
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
        );
        
        if (response.status === 200 && response.data.success) {
            return { success: true, message: response.data.message, data: response.data.data };
        }
        return { success: false, message: response.data.message || 'Failed to update PO archive status' };
    } catch (err) {
        console.error('🔴 ReceiveContext - updatePOArchive Error:', err);
        return { success: false, message: err.response?.data?.message || 'Error updating PO archive status' };
    }
};

const updatePOArchivePoLineItem = async (poNum, poLineItemId, archived) => {
    try {
        const response = await axios.patch(
            `${contextPath}/orderService/updatePOArchivePoLineItem`,
            {
                poNum: poNum,
                poLineItemId: poLineItemId,
                archived: archived
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
        );
        
        if (response.status === 200 && response.data.success) {
            return { success: true, message: response.data.message, data: response.data.data };
        }
        return { success: false, message: response.data.message || 'Failed to update PO line item archive status' };
    } catch (err) {
        console.error('🔴 ReceiveContext - updatePOArchivePoLineItem Error:', err);
        return { success: false, message: err.response?.data?.message || 'Error updating PO line item archive status' };
    }
};

    const fetchArchivedPOs = async (index, maxRecords, searchTerm, sortColumn, sortDirection, po, prcpart, vendor, status, dueDays, startDate, endDate) => {
        try {
            const params = { index, maxRecords };
            if (searchTerm) params.searchTerm = searchTerm;
            if (sortColumn) { params.sortColumn = sortColumn; params.sortDirection = sortDirection; }
            if (po) params.po = po;
            if (prcpart) params.prcpart = prcpart;
            if (vendor) params.vendor = vendor;
            if (status) params.status = status;
            if (dueDays) params.dueDays = dueDays;
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;

            const response = await axios.get(`${contextPath}/receivingService/getArchivedPOs`, {
                params,
                withCredentials: true,
            });
            if (response.status !== 200) throw new Error(`Unexpected status ${response.status}`);
            return response.data;
        } catch (err) {
            if (err.response?.status === 401) {
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error('fetchArchivedPOs error:', err);
            return null;
        }
    };

    // Returns the flat list of active production order lines; null on error, [] when empty.
    const getProductionLines = async () => {
        try {
            const response = await axios.get(`${contextPath}/api/production-orders/lines`, {
                withCredentials: true,
            });
            return Array.isArray(response.data) ? response.data : [];
        } catch (err) {
            if (err.response?.status === 401) {
                localStorage.removeItem('jwt');
                navigate('/login');
            }
            console.error('getProductionLines error:', err);
            return null;
        }
    };

return { productionDetailsFeatch, VendorFeatch, getPOValidationData, updatePOReview, updatePOAccept, updatePOArchive, updatePOArchivePoLineItem, fetchArchivedPOs, getProductionLines };
};

export default ReceiveContext;


